// Shared utility for preparing chart/table data from scenarios and calculations
export function prepareChartData({
  visibleScenarios = [],
  calculationResults = {},
  scenarioVisibility = {},
  visibilitySettings = {},
}) {
  if (!visibleScenarios.length) return [];

  const chartData = [];
  const firstScenarioId = visibleScenarios[0].id;
  const scenarioResults = calculationResults.scenarioResults[firstScenarioId];

  if (!scenarioResults || !scenarioResults.years || scenarioResults.years.length === 0) {
    return [];
  }

  scenarioResults.years.forEach((year, index) => {
    const dataPoint = { year: Number(year) };
    visibleScenarios.forEach(scenario => {
      const results = calculationResults.scenarioResults[scenario.id];
      if (!results) return;
      const scenarioVis = scenarioVisibility[scenario.id] || {};
      const prefix = scenario.name;
      if (scenarioVis.showSalary && results.salaryData) {
        dataPoint[`${prefix} - Salary`] = results.salaryData[index] || 0;
      }
      if (scenarioVis.showPension && results.pensionData) {
        dataPoint[`${prefix} - Pension`] = results.pensionData[index] || 0;
      }
      if (scenarioVis.showTsp) {
        const tspBalance = results.tspBalanceData ? results.tspBalanceData[index] || 0 : 0;
        const isRetirementYear = index >= scenarioResults.years.indexOf(scenario.retirementYear);
        const tspWithdrawal = isRetirementYear ? (tspBalance * (scenario.withdrawalRate / 100)) : 0;
        dataPoint[`${prefix} - TSP`] = tspWithdrawal;
      }
      if (scenarioVis.showTSPBalance && results.tspBalanceData) {
        dataPoint[`${prefix} - TSP Balance`] = results.tspBalanceData[index] || 0;
      }
      if (scenarioVis.showFERSSupplement && results.supplementData) {
        if (index < results.supplementData.length) {
          dataPoint[`${prefix} - Supplement`] = results.supplementData[index] || 0;
        } else {
          dataPoint[`${prefix} - Supplement`] = 0;
        }
      }
      if (scenarioVis.showSocialSecurity && results.socialSecurityData) {
        dataPoint[`${prefix} - Social Security`] = results.socialSecurityData[index] || 0;
      }
      // New: Add Additional Income to dataPoint if visible
      if (scenarioVis.showAdditionalIncome && results.additionalIncomeData) {
        dataPoint[`${prefix} - Additional Income`] = results.additionalIncomeData[index] || 0;
      }
      if (scenarioVis.showTotal) {
        let total = 0;
        if (scenarioVis.showSalary && results.salaryData) total += (results.salaryData[index] || 0);
        if (scenarioVis.showPension && results.pensionData) total += (results.pensionData[index] || 0);
        if (scenarioVis.showTsp) {
          const tspBalance = results.tspBalanceData ? results.tspBalanceData[index] || 0 : 0;
          const isRetirementYear = index >= scenarioResults.years.indexOf(scenario.retirementYear);
          total += isRetirementYear ? (tspBalance * (scenario.withdrawalRate / 100)) : 0;
        }
        if (scenarioVis.showFERSSupplement && results.supplementData && index < results.supplementData.length) total += (results.supplementData[index] || 0);
        if (scenarioVis.showSocialSecurity && results.socialSecurityData) total += (results.socialSecurityData[index] || 0);
        // New: Include Additional Income in Total Income calculation if visible
        if (scenarioVis.showAdditionalIncome && results.additionalIncomeData) total += (results.additionalIncomeData[index] || 0);
        dataPoint[`${prefix} - Total Income`] = total;
      }
      if (visibilitySettings.calculateNpv && results.npvData?.data) {
        dataPoint[`${prefix} - NPV`] = results.npvData.data[index] || 0;
      }
    });
    // --- Calculate and Add Income Delta --- 
    if (visibilitySettings.showIncomeDelta && visibleScenarios.length >= 2) {
      const scen1 = visibleScenarios[0];
      const scen2 = visibleScenarios[1];
      const key1 = `${scen1.name} - Total Income`;
      const key2 = `${scen2.name} - Total Income`;
      
      // Check if both total income values were calculated and added to the dataPoint
      if (key1 in dataPoint && key2 in dataPoint) {
        const income1 = dataPoint[key1] || 0;
        const income2 = dataPoint[key2] || 0;
        dataPoint[`Income Delta (${scen2.name} - ${scen1.name})`] = income2 - income1;
      }
    }
    // --- End Income Delta --- 
    chartData.push(dataPoint);
  });
  return chartData;
}
